import React, { useEffect, useCallback } from "react";
import { Typography, Card } from "antd";
import Pageloader from "../../../components/loader";
import MetricsDashboardFilter from "./filter";
import ChartDonut from "./donut";
import moment from "moment";
import * as dashboardActions from "../../../redux/actions/dashboard.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { Title, Text } = Typography;

const pageName = "Metrics Dashboard";

const MetricsDashboard = (props) => {

  useEffect(() => {
    if (props?.formData?.storeId !== null){
        postLists(props.formData)
    }
  }, [props.formData])

  const postLists = useCallback(async(value) => {
    const [start, end] = (value?.date === null || value?.date === undefined) ? "" : value?.date;
    const pageFilterData = {
      ...value,
      startDate: start === undefined ? moment().toISOString() : start.add(5, "hours").toISOString(),
      endDate: end === undefined ? moment().toISOString() : end.add(5, "hours").toISOString(),
    };
    delete pageFilterData["date"];
    try {
      await props.dashboardActions.getMetricsDashboardAction(pageFilterData);
    } catch (e) {}
  }, [props.formData])


  return (
    <div className="page-content">
        <div className="page-content-header">
            <div className="pch">
                <Title level={2}>{pageName}</Title>
            </div>
            <div className="pch">
                <MetricsDashboardFilter />
            </div>
        </div>
        <div className="p-content">
            {props?.pageLoader ? <Pageloader/> :
              <div className="page-list width-equal-3 ffr">
                  {props.pageData.length !== 0 ? Object.values(props.pageData).map((val)=>{
                      return (<Card title={`${val?.title}`}>{val?.total_count !== 0 ? <ChartDonut count={val?.total_count} data={val?.data}/> : "Data not found"}</Card>)
                  }):"Data not found"}
              </div>
            }
        </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    formData: state.DashboardReducer.metricsDashboardFilter,
    pageData: state.DashboardReducer.metricsDashboardData,
    pageLoader: state.DashboardReducer.metricsDashboardLoader,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MetricsDashboard);